<template>
<ItpUsercontrol
  :loading="loading"
  :reloading="reloading"
  :loaded="loaded"
  :error="error"
  @reload="evh_7315092382398562_reload($event, {})"
>
  <DIV
    class="overflow-auto"
  >
    <ItpFormGroup
      labelColsMd="2"
      contentColsMd="8"
      name="name"
      :label="'Name'|pgettext('Template')"
      :labelAlign="labelAlign"
    >
      <ItpFormInput
        name="name"
        v-model="item.name"
        required
      >
      </ItpFormInput>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="2"
      contentColsMd="8"
      name="object_type"
      :label="'Object Type'|pgettext('Template')"
      :labelAlign="labelAlign"
    >
      <ItpFormSelect
        name="object_type"
        v-model="item.object_type"
        :options="objectTypes"
        required
      >
      </ItpFormSelect>
    </ItpFormGroup>
    <ItpFormGroup
      labelColsMd="2"
      contentColsMd="8"
      name="template_type"
      :label="'Template Type'|pgettext('Template')"
      :labelAlign="labelAlign"
    >
      <ItpFormSelect
        name="template_type"
        v-model="item.template_type"
        :options="templateTypes"
        required
      >
      </ItpFormSelect>
    </ItpFormGroup>
    <hr
      :style="b_4892266742011185_style"
    >
    </hr>
    <ItpText
      :text="'Subject'|pgettext('Template')"
      strong
    >
    </ItpText>
    <CodeMirror
      mode="html"
      :options="b_5970972589163186_options"
      v-model="item.subject"
      class="border"
    >
    </CodeMirror>
    <hr
      :style="b_785371160721131_style"
    >
    </hr>
    <ItpText
      :text="'Header'|pgettext('Template')"
      strong
    >
    </ItpText>
    <CodeMirror
      mode="html"
      :options="b_253425746720918_options"
      v-model="item.header"
      class="border"
    >
    </CodeMirror>
    <hr
      :style="b_2748386552601189_style"
    >
    </hr>
    <ItpText
      :text="'Content'|pgettext('Template')"
      strong
    >
    </ItpText>
    <CodeMirror
      mode="html"
      :options="b_1712041292317581_options"
      v-model="item.content"
      class="border"
    >
    </CodeMirror>
    <hr
      :style="b_539880003873724_style"
    >
    </hr>
    <ItpText
      :text="'Footer'|pgettext('Template')"
      strong
    >
    </ItpText>
    <CodeMirror
      mode="html"
      :options="b_6324823719113312_options"
      v-model="item.footer"
      class="border"
    >
    </CodeMirror>
    <hr
      :style="b_219110658038496_style"
    >
    </hr>
    <ItpText
      :text="'CSS'|pgettext('Template')"
      strong
    >
    </ItpText>
    <CodeMirror
      mode="css"
      :options="b_3034545286442485_options"
      v-model="item.css"
      class="border"
    >
    </CodeMirror>
    <hr
      :style="b_4556014673857397_style"
    >
    </hr>
    <ItpText
      :text="'Sample data'|pgettext('Template')"
      strong
    >
    </ItpText>
    <CodeMirror
      mode="json"
      :options="b_7786722825496231_options"
      v-model="context.sampleData"
      class="border"
    >
    </CodeMirror>
  </DIV>
</ItpUsercontrol>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class UcTemplate extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "usercontrol",
  };

  beforeCreate() {
    this.$$cache_emailAddress = new ComponentValueCache(this, "emailAddress", "Template.emailAddress");
  }

  @Prop({
    required: true,
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: Object,
  })
  context!: object;

  @Watch('context')
  onContext(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("context")
  }

  labelAlign!: any;
  objectTypes!: any;

  async $$load_objectTypes() {
    return this.$fn.getEnumValuesFromSchema('ObjectTypes')
  }

  templateTypes!: any;

  async $$load_templateTypes() {
    return this.$fn.getEnumValuesFromSchema('TemplateTypes')
  }

  sampleDataSearchResult!: any;
  previewData!: any;
  emailAddress!: any;

  async $$load_emailAddress() {
    return this.$app.auth.user.email
  }

  ux!: any;
  b_4892266742011185_style!: any;
  b_5970972589163186_options!: any;
  b_785371160721131_style!: any;
  b_253425746720918_options!: any;
  b_2748386552601189_style!: any;
  b_1712041292317581_options!: any;
  b_539880003873724_style!: any;
  b_6324823719113312_options!: any;
  b_219110658038496_style!: any;
  b_3034545286442485_options!: any;
  b_4556014673857397_style!: any;
  b_7786722825496231_options!: any;
  dataMembers = ['labelAlign', 'objectTypes', 'templateTypes', 'sampleDataSearchResult', 'previewData', 'emailAddress', 'ux', 'b_4892266742011185_style', 'b_5970972589163186_options', 'b_785371160721131_style', 'b_253425746720918_options', 'b_2748386552601189_style', 'b_1712041292317581_options', 'b_539880003873724_style', 'b_6324823719113312_options', 'b_219110658038496_style', 'b_3034545286442485_options', 'b_4556014673857397_style', 'b_7786722825496231_options'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        labelAlign: "left",
        objectTypes: null,
        templateTypes: null,
        sampleDataSearchResult: null,
        previewData: null,
        emailAddress: null,
        ux: null,
        b_4892266742011185_style: {
          width: "20px",
        }
        ,
        b_5970972589163186_options: {
          lineNumbers: true,
          matchBrackets: true,
          continueComments: "Enter",
          extraKeys: {
            "Ctrl-Q": "toggleComment",
          }
          ,
        }
        ,
        b_785371160721131_style: {
          width: "20px",
        }
        ,
        b_253425746720918_options: {
          lineNumbers: true,
          matchBrackets: true,
          continueComments: "Enter",
          extraKeys: {
            "Ctrl-Q": "toggleComment",
          }
          ,
        }
        ,
        b_2748386552601189_style: {
          width: "20px",
        }
        ,
        b_1712041292317581_options: {
          lineNumbers: true,
          matchBrackets: true,
          continueComments: "Enter",
          extraKeys: {
            "Ctrl-Q": "toggleComment",
          }
          ,
        }
        ,
        b_539880003873724_style: {
          width: "20px",
        }
        ,
        b_6324823719113312_options: {
          lineNumbers: true,
          matchBrackets: true,
          continueComments: "Enter",
          extraKeys: {
            "Ctrl-Q": "toggleComment",
          }
          ,
        }
        ,
        b_219110658038496_style: {
          width: "20px",
        }
        ,
        b_3034545286442485_options: {
          lineNumbers: true,
          matchBrackets: true,
          continueComments: "Enter",
          extraKeys: {
            "Ctrl-Q": "toggleComment",
          }
          ,
        }
        ,
        b_4556014673857397_style: {
          width: "20px",
        }
        ,
        b_7786722825496231_options: {
          lineNumbers: true,
          matchBrackets: true,
          continueComments: "Enter",
          extraKeys: {
            "Ctrl-Q": "toggleComment",
          }
          ,
        }
        ,
      },
    }
  }

  async evh_7315092382398562_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_reloadComponentData_5818: actions.ReloadComponentDataAction;
    evh_7315092382398562_reload_5817: actions.EventHandlerImpl;
    evh_7315092382398562_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_reloadComponentData_5818 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_7315092382398562_reload_5817 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_reloadComponentData_5818,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_7315092382398562_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_reload_5817],
      }
    );
    return {
      act_7315092382398562_reloadComponentData_5818,
      evh_7315092382398562_reload_5817,
      evh_7315092382398562_reload,
    }
  }
}

Vue.component("UcTemplate", UcTemplate);

</script>